import React, { useCallback, useRef, useState } from "react";
import { H2, SystemMessage, Text } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { WIZARD_STEP_PATH } from "../../constants/paths";
import MetaWizardFooter from "../../elements/MetaWizard/MetaWizardFooter";
import MetaWizardHeader from "../../elements/MetaWizard/MetaWizardHeader";
import { MonthlyBudget } from "../../elements/MonthlyBudget";
import WizardHeader from "../../elements/WizardHeader";
import { AdSystemT, WizardStepT } from "../../graphql/generated/graphql";
import { useRecommendedMonthlyBudget } from "../../hooks/useRecommendedMonthlyBudget";
import { useSetWizardStepEffect } from "./useSetWizardStepEffect";

export const MetaBudget = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Meta Budget" });
  const navigate = useNavigate();
  const { recommendedMonthlyBudget } = useRecommendedMonthlyBudget();

  const [budgetValid, setBudgetValid] = useState(false);
  const saveRef = useRef<(() => Promise<void>) | null>(null);

  const handleBudgetStateChange = useCallback((_budget: number, isValid: boolean) => {
    setBudgetValid(isValid);
  }, []);

  const backButtonHandler = () => {
    navigate(WIZARD_STEP_PATH.META_TEXT_SELECTION);
  };

  const nextButtonHandler = async () => {
    try {
      await saveRef.current?.();
      navigate(WIZARD_STEP_PATH.META_FINISH);
    } catch {
      // Error is displayed by MonthlyBudget component
    }
  };

  useSetWizardStepEffect({ adSystem: AdSystemT.MetaAdsT, wizardStep: WizardStepT.MetaBudgetT });
  return (
    <div>
      <WizardHeader />
      <MetaWizardHeader activeStep={5} />
      <div>
        <H2 divider={false}>{t("Heading")}</H2>
      </div>
      <div style={{ maxWidth: "540px" }}>
        <Text>{t("Description", { minSum: "5000 Kc" })}</Text>
      </div>
      <div>
        <SystemMessage
          level="notice"
          description={
            <Text>
              <Trans
                components={{ b: <b /> }}
                i18nKey="Info"
                t={t}
                values={{ recommendedAmount: recommendedMonthlyBudget }}
              />
            </Text>
          }
        />
      </div>
      <div
        style={{
          backgroundColor: "var(--app-surface-muted)",
          borderRadius: "var(--app-radius-box)",
          marginTop: "20px",
          padding: "15px 10px",
        }}
      >
        <MonthlyBudget
          adSystem={AdSystemT.MetaAdsT}
          saveRef={saveRef}
          hideButtons
          onBudgetStateChange={handleBudgetStateChange}
        />
      </div>
      <MetaWizardFooter
        backButtonHandler={backButtonHandler}
        nextButtonDisabled={!budgetValid}
        nextButtonHandler={nextButtonHandler}
      />
    </div>
  );
};
